"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityLogAction = exports.AnalyticsReports = exports.SynonymType = exports.CalloutType = exports.PinType = exports.PinSource = exports.CurationStatusLabel = exports.CurationStatus = exports.CurationTypeLabel = exports.CurationType = exports.SettingsCurationsImageOption = exports.MerchandisingCalloutAutofillBehaviour = exports.ManageAdminFlag = exports.TaskSyncBulkDownloadTypeLabel = exports.ResourceTypeLabel = exports.ResourceType = void 0;
exports.isPinProduct = isPinProduct;
exports.isPinCallout = isPinCallout;
var ResourceType;
(function (ResourceType) {
    ResourceType["ActivityLog"] = "activity_log";
    ResourceType["Product"] = "product";
    ResourceType["Collection"] = "collection";
    ResourceType["Curation"] = "curation";
    ResourceType["Callout"] = "callout";
    ResourceType["SettingsAccount"] = "account_settings";
    ResourceType["SettingsAutomation"] = "automation_settings";
    ResourceType["SettingsProduct"] = "product_settings";
    ResourceType["FilterGroup"] = "filter_group";
    ResourceType["FilterFacet"] = "filter_facet";
    ResourceType["MergedValue"] = "merged_value";
    ResourceType["Redirect"] = "redirect";
    ResourceType["Relevancy"] = "relevancy";
    ResourceType["Sort"] = "sort";
    ResourceType["Antonym"] = "antonym";
    ResourceType["Synonym"] = "synonym";
    ResourceType["Task"] = "task";
})(ResourceType || (exports.ResourceType = ResourceType = {}));
exports.ResourceTypeLabel = {
    [ResourceType.ActivityLog]: "Activity log",
    [ResourceType.Product]: "Product",
    [ResourceType.Collection]: "Collection",
    [ResourceType.Curation]: "Curation",
    [ResourceType.Callout]: "Callout",
    [ResourceType.SettingsAccount]: "Settings account",
    [ResourceType.SettingsAutomation]: "Settings automation",
    [ResourceType.SettingsProduct]: "Settings product",
    [ResourceType.FilterGroup]: "Filter group",
    [ResourceType.FilterFacet]: "Filter facet",
    [ResourceType.MergedValue]: "Merged value",
    [ResourceType.Redirect]: "Redirect",
    [ResourceType.Relevancy]: "Relevancy",
    [ResourceType.Sort]: "Sort",
    [ResourceType.Antonym]: "Antonym",
    [ResourceType.Synonym]: "Synonym",
    [ResourceType.Task]: "Task",
};
exports.TaskSyncBulkDownloadTypeLabel = {
    collection: "collection details",
    product: "product details",
    product_market: "product market details",
};
var ManageAdminFlag;
(function (ManageAdminFlag) {
    ManageAdminFlag["Example"] = "example";
})(ManageAdminFlag || (exports.ManageAdminFlag = ManageAdminFlag = {}));
var MerchandisingCalloutAutofillBehaviour;
(function (MerchandisingCalloutAutofillBehaviour) {
    MerchandisingCalloutAutofillBehaviour["Always"] = "always";
    MerchandisingCalloutAutofillBehaviour["MoreResults"] = "more_results";
})(MerchandisingCalloutAutofillBehaviour || (exports.MerchandisingCalloutAutofillBehaviour = MerchandisingCalloutAutofillBehaviour = {}));
var SettingsCurationsImageOption;
(function (SettingsCurationsImageOption) {
    SettingsCurationsImageOption["Index"] = "index";
    SettingsCurationsImageOption["Suffix"] = "suffix";
})(SettingsCurationsImageOption || (exports.SettingsCurationsImageOption = SettingsCurationsImageOption = {}));
var CurationType;
(function (CurationType) {
    CurationType["Search"] = "search";
    CurationType["Collection"] = "collection";
})(CurationType || (exports.CurationType = CurationType = {}));
;
exports.CurationTypeLabel = {
    [CurationType.Search]: "Search",
    [CurationType.Collection]: "Collection",
};
var CurationStatus;
(function (CurationStatus) {
    CurationStatus["Draft"] = "draft";
    CurationStatus["Publishing"] = "publishing";
    CurationStatus["Published"] = "published";
    CurationStatus["Error"] = "error";
    CurationStatus["Unpublishing"] = "unpublishing";
    CurationStatus["Resetting"] = "resetting";
    CurationStatus["Pinning"] = "pinning";
    CurationStatus["Sorting"] = "sorting";
})(CurationStatus || (exports.CurationStatus = CurationStatus = {}));
exports.CurationStatusLabel = {
    [CurationStatus.Draft]: "Draft",
    [CurationStatus.Publishing]: "Publishing",
    [CurationStatus.Published]: "Published",
    [CurationStatus.Error]: "Error",
    [CurationStatus.Unpublishing]: "Unpublishing",
    [CurationStatus.Resetting]: "Resetting",
    [CurationStatus.Pinning]: "Pinning",
    [CurationStatus.Sorting]: "Sorting",
};
var PinSource;
(function (PinSource) {
    PinSource["Manual"] = "manual";
    PinSource["Automatic"] = "automatic";
})(PinSource || (exports.PinSource = PinSource = {}));
var PinType;
(function (PinType) {
    PinType["Product"] = "product";
    PinType["Callout"] = "callout";
})(PinType || (exports.PinType = PinType = {}));
function isPinProduct(pin) {
    return PinType.Product === pin.type;
}
function isPinCallout(pin) {
    return PinType.Callout === pin.type;
}
var CalloutType;
(function (CalloutType) {
    CalloutType["Standard"] = "standard";
    CalloutType["Filler"] = "filler";
})(CalloutType || (exports.CalloutType = CalloutType = {}));
var SynonymType;
(function (SynonymType) {
    SynonymType["Group"] = "group";
    SynonymType["Oneway"] = "oneway";
})(SynonymType || (exports.SynonymType = SynonymType = {}));
var AnalyticsReports;
(function (AnalyticsReports) {
    AnalyticsReports["Sales7Days"] = "sales_7days";
    AnalyticsReports["Sales30Days"] = "sales_30days";
    AnalyticsReports["Revenue7Days"] = "revenue_7days";
    AnalyticsReports["Revenue30Days"] = "revenue_30days";
})(AnalyticsReports || (exports.AnalyticsReports = AnalyticsReports = {}));
var ActivityLogAction;
(function (ActivityLogAction) {
    ActivityLogAction["Create"] = "create";
    ActivityLogAction["Delete"] = "delete";
    ActivityLogAction["Duplicate"] = "duplicate";
    ActivityLogAction["Sync"] = "sync";
    ActivityLogAction["Trigger"] = "trigger";
    ActivityLogAction["Update"] = "update";
})(ActivityLogAction || (exports.ActivityLogAction = ActivityLogAction = {}));
//# sourceMappingURL=firestore.js.map